import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  ADMIN_SEARCH_USERNAME_REQUEST,
  FETCH_TICKETS_REQUEST,
  FETCH_TICKET_MESSAGES_REQUEST,
  TICKET_DOCUMENT_REJECTION_REASONS,
  _SUCCESS,
} from "./constants";
import { Action, TicketMessageState, TicketsState } from "./types";
import { Reasons } from "../../components/tickets/ticket-document";

function items(state: TicketsState = { currentPage: 0, pageCount: 1, data: [] }, action: Action): TicketsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_TICKETS_REQUEST):
      return {
        ...action.payload,
        data: action.payload.currentPage === 1 ? [...action.payload.data] : [...state.data, ...action.payload.data],
      };
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_TICKETS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_TICKETS_REQUEST):
    case getFailureActionType(FETCH_TICKETS_REQUEST):
      return false;

    default:
      return state;
  }
}

function adminList(state: any[] = [], action: Action): any {
  switch (action.type) {
    case ADMIN_SEARCH_USERNAME_REQUEST + _SUCCESS:
      return action.payload.data;

    default:
      return state;
  }
}

function messages(
  state: TicketMessageState = { data: [], isFetching: false, file_link: "" },
  action: Action
): TicketMessageState {
  switch (action.type) {
    case getSuccessActionType(FETCH_TICKET_MESSAGES_REQUEST):
      return { data: action.payload, isFetching: false, file_link: "" };
    case FETCH_TICKET_MESSAGES_REQUEST:
      return { ...state, isFetching: true };
    case getFailureActionType(FETCH_TICKET_MESSAGES_REQUEST):
      return { data: [], isFetching: false, file_link: "" };
    default:
      return state;
  }
}

const initialState: Reasons[] = [];
const saveTicketDocumentRejectionReasons = (state = initialState, action: Action): Reasons[] => {
  switch (action.type) {
    case TICKET_DOCUMENT_REJECTION_REASONS:
      if (Array.isArray(action.payload)) {
        return action.payload;
      }
      return state;

    default:
      return state;
  }
};

export const tickets = combineReducers({ items, isFetching, messages, saveTicketDocumentRejectionReasons, adminList });
